import { profileFormStore, appStore } from '../../store/Store';
import ReactSpeedometer from 'react-d3-speedometer';
import '../../theme/RiskWidget.css';
import {
    IonCard,
    IonCardHeader,
    IonCardTitle,
    IonCardContent,
    IonCardSubtitle,
} from '@ionic/react';

function RiskWidget() {
    const userInfo = appStore.useState((s) => s.userInfo);

    const labels = [
        {
            text: 'Low',
            position: 'OUTSIDE',
            // color: isDark ? '#fff' : '#555',
            color: '#555',
        },
        {
            text: 'Moderate',
            position: 'OUTSIDE',
            // color: isDark ? '#fff' : '#555',
            color: '#555',
        },
        {
            text: 'High',
            position: 'OUTSIDE',
            // color: isDark ? '#fff' : '#555',
            color: '#555',
        },
        {
            text: 'Extreme',
            position: 'OUTSIDE',
            // color: isDark ? '#fff' : '#555',
            color: '#555',
        },
    ];

    return (
        <IonCard mode='ios' className='risk-widget'>
            <div
                style={{
                    width: 'auto',
                    height: '150px',
                    margin: '20px auto 25px auto',
                }}
            >
                <div className='ion-text-center'>
                    <ReactSpeedometer
                        paddingVertical={10}
                        maxValue={4}
                        value={userInfo.riskLevel - 0.5}
                        needleColor={'#5260ff'}
                        needleHeightRatio={0.45}
                        segments={4}
                        // customSegmentStops={[0, 1.5, 2.5, 3.5, 5.0]}
                        segmentColors={[
                            // "#3dc2ff",
                            '#2dd36f',
                            '#ffc409',
                            '#ff6600',
                            '#ff0000',
                        ]}
                        customSegmentLabels={labels}
                        currentValueText={`${userInfo.riskLevel}`}
                    />
                </div>
            </div>
            <IonCardHeader>
                <IonCardSubtitle>Current</IonCardSubtitle>
                <IonCardTitle>Fire Risk Level: {userInfo && userInfo.riskLevel}</IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
                {userInfo && userInfo.fireban ? (
                    <p>
                        Local conditions pose extreme fire risk. Serious fires can start easily,
                        spread quickly, burn intensely, and be very difficult to control. NO OPEN
                        AIR FIRE PERMITTED.
                    </p>
                ) : userInfo && userInfo.riskLevel === 1 ? (
                    <p>
                        Weather and ground conditions pose a low risk to accidental fire spread.
                        Please burn responsibly.
                    </p>
                ) : userInfo && userInfo.riskLevel === 2 ? (
                    <p>
                        Use care when open air burning. Local conditions pose potential for fires to
                        spread accidentally, especially on dry or windy days.
                    </p>
                ) : userInfo && userInfo.riskLevel === 3 ? (
                    <p>
                        Use caution when open air burning. Dry local conditions could allow fires to
                        spread easily and be difficult to control.
                    </p>
                ) : userInfo && userInfo.riskLevel === 4 ? (
                    <p>
                        Use extreme caution. Fires could spread quickly and beyond ability to
                        control. Postponing open air burning is recommended.
                    </p>
                ) : null}
            </IonCardContent>
        </IonCard>
    );
}

export default RiskWidget;
